
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SunBeamsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const count = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.2 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        for (let i = 0; i < count; i++) {
            const angle = (i / count) * Math.PI * 0.5 + Math.sin(curTime + i) * 0.1;
            const w = (50 + i * 20) * scale;
            
            const draw = () => {
                ctx.save();
                ctx.rotate(angle);
                const grad = ctx.createLinearGradient(0, 0, width * 2, 0);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                
                ctx.fillStyle = grad;
                ctx.globalAlpha *= 0.2 / layerIndex;
                ctx.fillRect(0, -w/2, width * 2, w);
                ctx.restore();
            };
            draw();
            this.applyGlow(pc, draw);
        }
    }
}
